import React from 'react';
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import '../Editor/styles.css';
import './styles.css';

const QuillRenderer = ({ content, className = '' }) => {
  if (!content) return null;

  return (
    <div className={`quill-content-renderer ${className}`}>
      <div
        className="ql-container ql-snow"
        style={{ border: 'none' }}
      >
        <div
          className="ql-editor"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </div>
  );
};

export default QuillRenderer;
